export default __webpack_public_path__ + "static/media/1.a77e3033.jpg";